import { render, staticRenderFns } from "./address-book-mobile-picker.vue?vue&type=template&id=15a8c5d2&"
import script from "./address-book-mobile-picker.vue?vue&type=script&lang=js&"
export * from "./address-book-mobile-picker.vue?vue&type=script&lang=js&"
import style0 from "./address-book-mobile-picker.vue?vue&type=style&index=0&id=15a8c5d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports